import { getOssUploadUrl, uploadReport } from '@/api/open'
// import SparkMD5 from 'spark-md5';
import md5 from 'js-md5';

export default {
    components: {
    },
    model: {
        prop: 'url',
        event: 'change'
    },
    props: ['url', 'num', 'data'],
    data() {
        return {
            maxNum: 1,
            headers: {},
            uploadUrl: '',
            loading: false,
            previewVisible: false,
            previewImage: '',
            fileList: [],
            type: 2, //类型： 2-图片 3-视频
            materials: [],
            types: [],
            urls: [],
            reportRes: {},
            reportList: [],
            showList: [],
            // 上传重试相关状态：以 file.uid 为 key，每个文件独立状态机
            uploadStates: {},
            // 上传重试默认参数（可在调用处覆盖）
            uploadRetryConfig: {
                maxRetries: 3,          // 最大重试次数（总尝试 = 1 + maxRetries）
                stallTimeout: 30000,    // 无数据流动超时（ms）：超过该时长无字节推进判定卡死
                baseDelay: 1000,        // 首次重试退避基础时长（ms）
                maxDelay: 8000,         // 退避上限（ms）
                backoffFactor: 2,       // 指数退避倍数
                jitterRatio: 0.2,       // 抖动比例（±20%），避免多文件同时重试雪崩
            },
        }
    },
    computed: {
    },
    watch: {
        url(value) {
            if (this.fileList.length > 0) {
                return
            }
            // console.log('urlwatch',value)
            const items = typeof (value) === 'string' ? [value] : value
            this.setUrl(items)
        },
        materials() {
            //同步主组件值
            this.$emit('afterUpload', this.materials);
            this.loading = false
            // console.log('qqqqqqqqqqqqqqqqqqqqqq:this.materials', this.materials)
        },
        reportList: {
            handler(items) {
                // console.log("reportList改变：", items)
                let urls = []

                const materials = []
                for (let i = 0; i < items.length; i++) {
                    let item = items[i]
                    const url = item.url
                    urls.push(url)

                    if (item.returnData) {
                        if (!Array.isArray(this.materials)) {
                            this.materials = []
                        }
                        materials.push(item.returnData)
                        this.types[`${item.returnData.url}`] = item.returnData.type
                        this.showList[`${item.uid}`] = item.returnData
                    }
                }
                if (this.maxNum === 1) {
                    urls = urls[0]
                }
                // this.fileList = items
                this.materials = materials
                this.$emit('change', urls)
                // console.log('yyyyyyyyyyyyyyyyyyy', this.fileList)
            },
            deep: true
        }
    },
    mounted() {
        this.url && this.setUrl(this.url)
        this.maxNum = this.num || this.maxNum
        this.headers['Access-Token'] = localStorage.getItem('token')
        // 注册网络状态监听，离线时暂停重试，上线后自动续传
        window.addEventListener('online', this.handleOnline)
        window.addEventListener('offline', this.handleOffline)
    },
    beforeDestroy() {
        // 移除网络事件监听，避免组件销毁后回调访问已卸载实例
        window.removeEventListener('online', this.handleOnline)
        window.removeEventListener('offline', this.handleOffline)
        // abort 所有进行中的上传并释放引用，防止悬挂定时器/XHR
        this.abortAllUploads()
    },
    methods: {
        handleCancel() {
            this.previewVisible = false
        },
        async handlePreview(file) {
            const thisFile = this.showList[file.uid]
            this.previewImage = thisFile.url
            this.previewVisible = true
        },
        handleChange({ fileList }) {
            // console.log('change',fileList)
            //此处改为fileList绑定
            this.fileList = fileList
            if (this.fileList.length <= 0) {
                this.materials = {}
            }
        },
        remove(item) {
            // abort 进行中的上传（含重试/退避），释放带宽与状态
            this.abortUpload(item.uid)
            //移除reportList
            this.reportList = this.reportList.filter(obj => obj.uid !== item.uid);
        },
        beforeUpload(file) {
            this.loading = true
            let res
            let errorMessage = ''
            if (file.type.includes('image')) {
                this.type = 2
                const allowTypes = [
                    'image/jpg',
                    'image/jpeg',
                    'image/png',
                    'image/gif',
                ]

                const isImage = allowTypes.includes(file.type)
                if (!isImage) {
                    this.loading = false
                    errorMessage = '图片格式错误'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                const isLt2M = file.size / 1024 / 1024 < 10

                if (!isLt2M) {
                    this.loading = false
                    errorMessage = '图片大小不能超过 10MB'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                res = !!(isLt2M)
            } else {
                this.type = 3
                // file.response = { code: -1, message: '暂不支持视频' }
                // return false
                const isLt2M = file.size / 1024 / 1024 <= 2000;

                if (!isLt2M) {
                    this.loading = false
                    errorMessage = '视频大小不能超过 2000MB'
                    file.response = { code: -1, message: errorMessage }
                    this.$message.error(errorMessage);
                    return false
                }
                res = !!(isLt2M)
            }
            this.loading = true
            console.log('res', res)
            if (res) {
                new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const arrayBuffer = reader.result;
                        const md5 = this.calculateMD5(arrayBuffer);
                        resolve({ file, md5 });
                    };
                    reader.readAsArrayBuffer(file);
                });
            }
            this.loading = false
            return res

        },
        transformFile(file) {
            this.loading = true
            return new Promise((resolve) => {
                const reader = new FileReader();

                reader.onload = () => {
                    const transformedFile = file;

                    if (!file.md5) {
                        const arrayBuffer = reader.result;
                        const md5 = this.calculateMD5(arrayBuffer);
                        transformedFile.md5 = md5
                    }
                   
                    if (file.type.startsWith('image/')) {
                        const image = new Image();
                        image.onload = () => {
                            const width = image.width;
                            const height = image.height;
                            transformedFile.width = width;
                            transformedFile.height = height;
                            resolve(transformedFile);
                        };
                        // image.src = e.target.result;
                        image.src = URL.createObjectURL(file);
                    } else if (file.type.startsWith('video/')) {
                        const video = document.createElement('video');
                        video.onloadedmetadata = () => {
                            const width = video.videoWidth;
                            const height = video.videoHeight;
                            transformedFile.width = width;
                            transformedFile.height = height;
                            resolve(transformedFile);
                        };
                        // video.src = URL.createObjectURL(file);
                        video.src = URL.createObjectURL(file);
                    } else {
                        resolve(transformedFile);
                    }

                };
                reader.readAsArrayBuffer(file);
            });
        },
        customRequest({ file, onSuccess, onError, onProgress }) {

            this.loading = true
            //获取上传地址
            getOssUploadUrl({ name: file.name, type: this.type, md5: file.md5, 'upload_type': 'ddk' }).then(res => {
                this.$message.destroy()
                if (!(res && res.code === 0)) {
                    this.loading = false
                    return this.$message.error(res.message)
                }
                //判断是否急速快传
                if (res.data.is_quick_upload === true) {
                    this.loading = false
                    this.$message.error("素材已存在，请勿重复上传")
                    return onError(new Error('素材已存在，请勿重复上传'));
                }

                const uploadUrl = res.data.url
                // ★ 唯一改动点：原 XHR 整段替换为带重试的上传器
                // happy path（拿到地址后的上传+上报）逻辑全部封装在 uploadWithRetry 内部
                this.uploadWithRetry(file, uploadUrl, { onSuccess, onError, onProgress })
            })

        },
        setUrl(items) {
            if (!items) {
                return
            }
            if (typeof (items) === 'string') {
                items = [items]
            }
            for (let i = 0; i < items.length; i++) {
                this.fileList.push({
                    uid: (new Date()).getTime() + i,
                    name: 'image.png',
                    status: 'done',
                    url: items[i],
                })
            }
        },
        calculateMD5(data) {
            // 计算文件的 MD5 值
            return md5(data)
        },

        /**
         * 带重试的上传器：封装原 customRequest 拿到 uploadUrl 后的 XHR 上传逻辑
         * 职责：重试循环控制、进度基线管理、离线等待、取消拦截
         * 不负责：getOssUploadUrl、is_quick_upload 判断、uploadReport（后者在 singleAttempt 内部）
         * @param {File} file 文件对象（含 md5/width/height 等）
         * @param {String} uploadUrl OSS/PHP 预签名上传地址
         * @param {Object} callbacks { onSuccess, onError, onProgress } a-upload 回调
         */
        async uploadWithRetry(file, uploadUrl, { onSuccess, onError, onProgress }) {
            const uid = file.uid
            // 同一 uid 若已有进行中的上传，先清理（防止 a-upload 重复触发 customRequest 导致并发）
            if (this.uploadStates[uid]) {
                this.abortUpload(uid)
            }
            // 初始化该文件的状态机
            this.uploadStates[uid] = {
                baseline: 0,                // 已确认达到过的最高进度（0~100），保证重试时进度不回跳
                currentAttemptPercent: 0,   // 当前 attempt 的实时进度
                attempt: 0,                 // 当前尝试次数
                xhr: null,                  // 当前 XHR 引用，供 abort
                retryTimer: null,           // 退避倒计时句柄
                retryResolver: null,        // 退避等待 Promise 的 resolve，供取消/离线时唤醒
                stallTimer: null,           // 看门狗定时器句柄
                cancelled: false,           // 用户取消/组件销毁标记
                offline: false,             // 网络离线标记
                onlineResolver: null,       // 离线等待 Promise 的 resolve，由 handleOnline 调用唤醒
                retryHint: '',              // 副文本提示
            }
            const s = this.uploadStates[uid]
            const cfg = this.uploadRetryConfig
            const maxRetries = cfg.maxRetries

            // 总尝试次数 = 1 + maxRetries。最后一次失败时 attempt > maxRetries 成立，走 onError
            for (s.attempt = 1; s.attempt <= maxRetries + 1; s.attempt++) {
                // ---- 离线等待：不消耗 attempt 次数，等 online 唤醒 ----
                while (s.offline && !s.cancelled) {
                    s.retryHint = '网络已断开，等待恢复…'
                    onProgress({ percent: s.baseline, retryHint: s.retryHint })
                    await new Promise(resolve => { s.onlineResolver = resolve })
                    s.onlineResolver = null
                }
                if (s.cancelled) { this.cleanupUploadState(uid); return }

                // ---- 单次 attempt ----
                try {
                    // singleAttempt 内部：XHR onload 成功时调 uploadReport + onSuccess，然后 resolve
                    await this.singleAttempt(file, uploadUrl, uid, { onProgress, onSuccess })
                    // 成功（HTTP 201，uploadReport 已在 singleAttempt 内调完）
                    this.cleanupUploadState(uid)
                    return
                } catch (err) {
                    if (s.cancelled) { this.cleanupUploadState(uid); return }
                    // 判定是否可重试
                    if (!this.isRetryable(err)) {
                        this.loading = false
                        this.cleanupUploadState(uid)
                        // 不可重试（4xx 等）：维持原 onError 行为
                        return onError(new Error('上传失败'))
                    }
                    if (s.attempt > maxRetries) {
                        this.loading = false
                        this.cleanupUploadState(uid)
                        // 重试用尽：维持原 onError 行为
                        console.log(`[上传重试] ${file.name} 重试${maxRetries}次仍失败`)
                        return onError(new Error('上传失败'))
                    }
                    // 可重试 → 进入退避，进度条保持基线不回跳
                    s.retryHint = `网络不稳，正在重试 (${s.attempt}/${maxRetries})…`
                    onProgress({ percent: s.baseline, retryHint: s.retryHint })
                    this.fileList = this.fileList.map((item) =>
                        item.uid === uid ? { ...item, percent: s.baseline, retryHint: s.retryHint } : item
                    )
                    console.log(`[上传重试] ${file.name} 第${s.attempt}次重试，原因：${err.type}`)
                    await this.waitForRetry(uid, s.attempt)
                    if (s.cancelled) { this.cleanupUploadState(uid); return }
                    // 循环回到 for 顶部，发起新 attempt
                }
            }
        },

        /**
         * 单次上传尝试：封装原 XHR 逻辑，返回 Promise
         * 成功（HTTP 201）：在 onload 内部调 uploadReport + onSuccess，然后 resolve
         * 失败：reject({ type: 'network' | 'http', status? })，由 uploadWithRetry 决定重试
         * @param {File} file 文件对象
         * @param {String} uploadUrl 上传地址
         * @param {String|Number} uid 文件唯一标识
         * @param {Object} callbacks { onProgress, onSuccess }
         */
        singleAttempt(file, uploadUrl, uid, { onProgress, onSuccess }) {
            const s = this.uploadStates[uid]
            const cfg = this.uploadRetryConfig
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest()
                s.xhr = xhr // 存引用供 abort
                xhr.open('PUT', uploadUrl, true)
                xhr.setRequestHeader('Content-Type', '')

                // ---- stall 看门狗：持续 setInterval，超过 stallTimeout 无字节推进则 abort ----
                let lastLoadedTime = Date.now()
                let lastLoaded = 0
                s.stallTimer = setInterval(() => {
                    if (Date.now() - lastLoadedTime >= cfg.stallTimeout) {
                        xhr.abort() // 触发 onerror，被下方 reject 捕获
                    }
                }, 1000)

                // ---- 上传进度回调（过进度基线算法，保证重试时进度不回跳）----
                xhr.upload.onprogress = (event) => {
                    if (event.lengthComputable) {
                        const loaded = event.loaded
                        const total = event.total
                        // 有字节推进才刷新看门狗时间戳
                        if (loaded > lastLoaded) {
                            lastLoadedTime = Date.now()
                            lastLoaded = loaded
                        }
                        this.handleProgress(uid, loaded, total, onProgress)
                    }
                }

                // ---- 上传成功回调：原 onload 成功分支逻辑原样保留 ----
                xhr.onload = () => {
                    clearInterval(s.stallTimer)
                    if (xhr.status === 201) {
                        const responseText = JSON.parse(xhr.responseText)
                        let url = responseText.url
                        const cover_url = responseText.cover_url
                        this.loading = false

                        // 进度置 100
                        s.baseline = 100
                        s.retryHint = ''
                        onProgress({ percent: 100, retryHint: '' })

                        // 上报服务器，返回关键信息（与原代码一致）
                        uploadReport({
                            name: file.name,
                            url: url,
                            cover_url: cover_url,
                            md5: file.md5,
                            mime_type: file.type,
                            size: file.size,
                            width: file.width,
                            height: file.height
                        }).then(res => {
                            if (res && res.code === 0) {
                                this.loading = false
                                let returnData = res.data
                                returnData.video_cover = cover_url
                                const reportUrl = res.data.url

                                this.reportList.push({
                                    uid: file.uid,
                                    name: file.name,
                                    status: 'done',
                                    url: reportUrl,
                                    video_cover: cover_url,
                                    returnData: returnData
                                })

                                this.fileList = this.fileList.map((item) =>
                                    item.uid === file.uid ? { ...item, status: 'done', url: reportUrl } : item
                                )
                            }
                        })
                        onSuccess()
                        resolve() // 告知 uploadWithRetry 本次成功
                    } else {
                        reject({ type: 'http', status: xhr.status })
                    }
                }

                // ---- 上传失败回调 ----
                xhr.onerror = () => {
                    clearInterval(s.stallTimer)
                    // 取消触发的 abort：吞掉，不判失败（uploadWithRetry 会检查 cancelled 自行退出）
                    if (s.cancelled) { resolve(); return }
                    // stall 超时和真实网络错误统一归为 network 类型
                    reject({ type: 'network' })
                }

                xhr.send(file)
            })
        },

        /**
         * 进度基线算法核心：保证重试时进度条不回跳
         * displayPercent = max(baseline, currentAttemptPercent)
         * 重试过程中 currentAttemptPercent 从 0 重新爬升，但 baseline 保持断点值
         * 直到当前 attempt 进度超过 baseline，才刷新基线并继续前进
         */
        handleProgress(uid, loaded, total, onProgress) {
            const s = this.uploadStates[uid]
            if (!s) return
            s.currentAttemptPercent = Math.floor((loaded / total) * 100)
            // 创新高：上调基线，副文本恢复空（正常上传观感）
            if (s.currentAttemptPercent > s.baseline) {
                s.baseline = s.currentAttemptPercent
                s.retryHint = ''
            }
            const display = Math.max(s.baseline, s.currentAttemptPercent)
            onProgress({ percent: display, retryHint: s.retryHint })
            this.fileList = this.fileList.map((item) =>
                item.uid === uid ? { ...item, percent: display } : item
            )
        },

        /**
         * 判定失败是否可重试
         * 网络错误（含 stall abort）、5xx、408/425/429 可重试
         * 4xx 其他、2xx 非 201 不重试（如 403 签名过期，重试也是失败）
         */
        isRetryable(err) {
            if (err.type === 'network') return true
            if (err.type === 'http' && err.status >= 500) return true
            if (err.type === 'http' && [408, 425, 429].includes(err.status)) return true
            return false
        },

        /**
         * 退避等待：指数退避 + 抖动，句柄存入 retryTimer 供取消
         * resolve 函数存入 retryResolver，供 handleOffline/abortUpload 唤醒，防止死锁
         */
        waitForRetry(uid, attempt) {
            const cfg = this.uploadRetryConfig
            // 指数退避：baseDelay * backoffFactor^(attempt-1)，封顶 maxDelay
            let delay = cfg.baseDelay * Math.pow(cfg.backoffFactor, attempt - 1)
            delay = Math.min(delay, cfg.maxDelay)
            // 抖动：±jitterRatio
            const jitter = delay * cfg.jitterRatio
            delay = delay + (Math.random() * 2 - 1) * jitter
            delay = Math.max(0, Math.round(delay))

            const s = this.uploadStates[uid]
            return new Promise(resolve => {
                s.retryResolver = resolve
                s.retryTimer = setTimeout(() => {
                    s.retryTimer = null
                    s.retryResolver = null
                    resolve()
                }, delay)
            })
        },

        /**
         * 取消单个文件上传：标记取消、清计时器、abort XHR、释放状态
         * abort 触发的 onerror 会被 singleAttempt 吞掉（cancelled=true），不判失败
         */
        abortUpload(uid) {
            const s = this.uploadStates[uid]
            if (!s) return
            s.cancelled = true
            if (s.retryTimer) { clearTimeout(s.retryTimer); s.retryTimer = null }
            if (s.retryResolver) { s.retryResolver(); s.retryResolver = null } // 唤醒退避等待，防止死锁
            if (s.stallTimer) { clearInterval(s.stallTimer); s.stallTimer = null }
            if (s.onlineResolver) { s.onlineResolver(); s.onlineResolver = null } // 唤醒可能正在等待离线的循环
            if (s.xhr) { s.xhr.abort(); s.xhr = null }
            console.log(`[上传重试] uid=${uid} 已取消`)
            delete this.uploadStates[uid]
        },

        /**
         * abort 所有进行中的上传（组件销毁时调用）
         */
        abortAllUploads() {
            Object.keys(this.uploadStates).forEach(uid => {
                this.abortUpload(uid)
            })
            this.uploadStates = {}
        },

        /**
         * 清理单个文件的上传状态（成功/失败/取消后调用）
         * 释放计时器句柄和 XHR 引用，防止内存累积
         */
        cleanupUploadState(uid) {
            const s = this.uploadStates[uid]
            if (!s) return
            if (s.retryTimer) { clearTimeout(s.retryTimer); s.retryTimer = null }
            if (s.retryResolver) { s.retryResolver(); s.retryResolver = null }
            if (s.stallTimer) { clearInterval(s.stallTimer); s.stallTimer = null }
            if (s.onlineResolver) { s.onlineResolver(); s.onlineResolver = null }
            if (s.xhr) { s.xhr = null }
            delete this.uploadStates[uid]
        },

        /**
         * 网络离线：abort 当前 XHR，停退避，不消耗 attempt 次数
         * 循环会在 uploadWithRetry 的 while(s.offline) 处暂停等待
         */
        handleOffline() {
            Object.keys(this.uploadStates).forEach(uid => {
                const s = this.uploadStates[uid]
                s.offline = true
                if (s.xhr) { s.xhr.abort() } // 主动掐断，避免长时间等 onerror
                if (s.retryTimer) { clearTimeout(s.retryTimer); s.retryTimer = null }
                if (s.retryResolver) { s.retryResolver(); s.retryResolver = null } // 唤醒退避等待，让循环回到顶部走离线等待
                s.retryHint = '网络已断开，等待恢复…'
                console.log(`[上传重试] uid=${uid} 网络断开`)
            })
        },

        /**
         * 网络恢复：唤醒所有离线等待的循环，从当前 attempt 重新发起
         */
        handleOnline() {
            Object.keys(this.uploadStates).forEach(uid => {
                const s = this.uploadStates[uid]
                if (s.cancelled) return
                s.offline = false
                // 唤醒正在 await 的 uploadWithRetry 循环
                if (s.onlineResolver) { s.onlineResolver(); s.onlineResolver = null }
                console.log(`[上传重试] uid=${uid} 网络恢复`)
            })
        },
    }
}
